export default __webpack_public_path__ + "static/media/undefinedfile.0f01221a.PNG";